export enum LocalStorageKeys {
  CURRENT_USER = 'currentUser'
}
